<template lang="pug">
    section#apoio
        .wrapper
            p.descricao
                |Precisa de um apoio para fazer a sua Graduação, Pós-Graduação ou Curso Técnico?
                br
                |Na UniFAEL você tem acesso a programas de bolsas para realizar o seu curso com mensalidades que cabem no seu bolso. Confira!
            .cards
                .card.degrade
                    p.validade
                        |Bolsas de
                        br
                        strong
                            |descontos
                            br
                            |especiais
                        img(:src="require('@images/logo/icone-bolsa-profael.png')")
                .card
                    p.validade
                        |Válido para
                        br
                        strong
                            |Graduação e
                            br
                            |Pós-Graduação e
                            br
                            |Técnico
</template>

<script>
export default {
    name: "section-apoio"
}
</script>

<style lang="stylus" scoped src="./Apoio.styl"></style>
